import React, { StrictMode } from "react"
import { createInertiaApp } from "@inertiajs/react"
import { createRoot } from "react-dom/client"
import * as Sentry from "@sentry/react"

import Layout from "@/pages/Layout/Layout"

Sentry.init({
  dsn: "https://bed8e829a693771c800e35a7780cfada@telebugs.tsubasa-technologies.co.jp/api/v1/sentry_errors/4",
  integrations: [],
  beforeSend(event, hint) {
    // Check if it is an exception, and if so, show the report dialog
    if (event.exception && event.event_id) {
      Sentry.showReportDialog({ eventId: event.event_id })
    }
    return event
  },
})

// Vite Error Overlay
window.onerror = (event, source, lineno, colno, err) => {
  const ErrorOverlay = customElements.get("vite-error-overlay")
  if (!ErrorOverlay) {
    return
  }
  const overlay = new ErrorOverlay(err)
  document.body.appendChild(overlay)
}

const pages = import.meta.glob("../pages/**/*.jsx")
createInertiaApp({
  resolve: async (name) => {
    const page = (await pages[`../pages/${name}.jsx`]()).default
    page.layout =
      page.layout ||
      ((page) => <Layout children={page} currentPageName={name} />)
    return page
  },
  setup({ App, el, props }) {
    createRoot(el).render(
      <StrictMode>
        <App {...props} />
      </StrictMode>
    )
  },
})
